import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import _ from "lodash";

function resetSavedData() {
  return actions.resetDataSaved();
}

function eliminarAlumno(idAlumno) {
  return dispatch => {
    let insert = {};
    insert[`detalles/alumnos/${idAlumno}`] = null;
    insert[`cobros/general/${idAlumno}`] = null;
    insert[`alumno_actividad/${idAlumno}`] = null;
    rootRef.update(insert);

    rootRef
      .child(`avisos`)
      .orderByChild("item")
      .equalTo(idAlumno)
      .on("child_added", snap => {
        let val = {};
        val[`avisos/${snap.key}`] = null;
        rootRef.update(val);
      });
  };
}

function obtenerDetalleAlumno(value) {
  return dispatch => {
    rootRef.child(`detalles/alumnos/${value}`).once("value", snap => {
      const payload = { ...snap.val(), ...{ id: snap.key } };
      dispatch(actions.obtenerDetalleAlumno(payload));
    });
  };
}

function resetDetalleAlumno() {
  return actions.resetDetalleAlumno();
}

function obtenerListaAlumnos() {
  return dispatch => {
    dispatch(attachOnAddedListaAlumnos());
    dispatch(attachOnRemovedListaAlumnos());
  };
}

function attachOnAddedListaAlumnos() {
  return dispatch =>
    rootRef.child("detalles/alumnos").on("child_added", snap => {
      const payload = { ...snap.val(), ...{ id: snap.key } };
      dispatch(actions.itemAddedListaAlumnos(payload));
    });
}

function attachOnRemovedListaAlumnos() {
  return dispatch =>
    rootRef
      .child("detalles/alumnos")
      .on("child_removed", snap =>
        dispatch(actions.itemRemovedListaAlumnos(snap.key))
      );
}

function resetListaAlumnos() {
  return dispatch => {
    rootRef.child("detalles/alumnos").off("child_added");
    rootRef.child("detalles/alumnos").off("child_removed");
    dispatch(actions.resetListaAlumnos());
  };
}

function saveDataAlumno(values) {
  const idAlumno = rootRef.child("detalles/alumnos").push().key;
  const timestamp = new Date().getTime();
  let insert = {};
  !values.hasOwnProperty("apellido2") && (values.apellido2 = "");
  !values.hasOwnProperty("avisos") && (values.avisos = {});

  if (!values.hasOwnProperty("iban")) {
    const idAviso = rootRef.child("avisos").push().key;
    let aviso = {
      item: idAlumno,
      tipo: "ALUMNOS_NO_IBAN",
      mensaje: "Falta el IBAN o no es correcto",
      timestamp,
      resuelto: false
    };
    insert[`avisos/${idAviso}`] = aviso;
    values.avisos["ALUMNOS_NO_IBAN"] = idAviso;
  }

  if (
    values.hasOwnProperty("contacto") &&
    !values.contacto.hasOwnProperty("telefono")
  ) {
    const idAviso = rootRef.child("avisos").push().key;
    let aviso = {
      item: idAlumno,
      tipo: "ALUMNOS_NO_TELEFONO",
      mensaje: "Falta el teléfono de contacto",
      timestamp,
      resuelto: false
    };
    insert[`avisos/${idAviso}`] = aviso;
    values.avisos["ALUMNOS_NO_TELEFONO"] = idAviso;
  }

  !values.hasOwnProperty("ampa") && (values.ampa = false);
  !values.hasOwnProperty("hermanos") && (values.hermanos = false);

  values.nombre = values.nombre.trim().toUpperCase();
  values.apellido1 = values.apellido1.trim().toUpperCase();
  values.apellido2 = values.apellido2.trim().toUpperCase();

  insert[`detalles/alumnos/${idAlumno}`] = values;

  return dispatch => rootRef.update(insert);
}

function updateDataAlumno(values) {
  const { id: idAlumno, avisos } = values;
  let insert = {};

  if (values.hasOwnProperty("avisos")) {
    if (avisos.hasOwnProperty("ALUMNOS_NO_IBAN")) {
      if (values.hasOwnProperty("iban") && !_.isEmpty(values.iban)) {
        insert[`avisos/${avisos["ALUMNOS_NO_IBAN"]}`] = null;
        avisos["ALUMNOS_NO_IBAN"] = null;
      }
    }

    if (avisos.hasOwnProperty("ALUMNOS_NO_TELEFONO")) {
      if (
        values.contacto.hasOwnProperty("telefono") &&
        !_.isEmpty(values.contacto.telefono)
      ) {
        insert[`avisos/${avisos["ALUMNOS_NO_TELEFONO"]}`] = null;
        avisos["ALUMNOS_NO_TELEFONO"] = null;
      }
    }
  } else {
    values.avisos = {};
    if (
      !values.hasOwnProperty("iban") ||
      (values.hasOwnProperty("iban") && _.isEmpty(values.iban))
    ) {
      const idAviso = rootRef.child(`avisos`).push().key;
      let aviso = {
        item: idAlumno,
        tipo: "ALUMNOS_NO_IBAN",
        mensaje: "Falta el IBAN o no es correcto",
        timestamp: new Date().getTime(),
        resuelto: false
      };
      insert[`avisos/${idAviso}`] = aviso;
      values.avisos["ALUMNOS_NO_IBAN"] = idAviso;
    }

    if (
      values.contacto &&
      (!values.contacto.hasOwnProperty("telefono") ||
        (values.contacto.hasOwnProperty("telefono") &&
          _.isEmpty(values.contacto.telefono)))
    ) {
      const idAviso = rootRef.child(`avisos`).push().key;
      let aviso = {
        item: idAlumno,
        tipo: "ALUMNOS_NO_TELEFONO",
        mensaje: "Falta el teléfono de contacto",
        timestamp: new Date().getTime(),
        resuelto: false
      };
      insert[`avisos/${idAviso}`] = aviso;
      values.avisos["ALUMNOS_NO_TELEFONO"] = idAviso;
    }
  }

  values.nombre = values.nombre.trim().toUpperCase();
  values.apellido1 = values.apellido1.trim().toUpperCase();
  values.apellido2 = values.apellido2.trim().toUpperCase();

  insert[`detalles/alumnos/${idAlumno}`] = values;
  return dispatch => rootRef.update(insert);
}

/*---*/
export {
  resetSavedData,
  eliminarAlumno,
  obtenerListaAlumnos,
  resetListaAlumnos,
  obtenerDetalleAlumno,
  updateDataAlumno,
  resetDetalleAlumno,
  saveDataAlumno
};



// WEBPACK FOOTER //
// ./src/ducks/alumnos/operations.js